import styled, { DefaultTheme, css } from 'styled-components';

export default styled.div`
  ${({ theme }: { theme: DefaultTheme }) => {
    return css`
      position: absolute;
      z-index: -1;

      > div:first-child {
        position: relative;
        display: flex;
        flex-direction: column;
        border-radius: 0.5em;
        background: var(--color-neutral-0);
        box-shadow: var(--box-shadow);
        width: calc(100dvw - 2em);

        @media ${theme.mq.min.mobile} {
          width: 25em;
        }
      }

      &[data-position='TopLeft'],
      &[data-position='CenterLeft'],
      &[data-position='TopRight'],
      &[data-position='CenterRight'] {
        @media ${theme.mq.max.tablet} {
          top: 4.625em;
          left: 1em;
        }
      }

      &[data-position='BottomLeft'],
      &[data-position='BottomRight'] {
        @media ${theme.mq.max.tablet} {
          bottom: 4.625em;
          left: 1em;
        }
      }

      &[data-position='TopLeft'] {
        @media ${theme.mq.min.tablet} {
          top: 0;
          left: 4.25em;
        }
      }

      &[data-position='CenterLeft'] {
        @media ${theme.mq.min.tablet} {
          top: 50%;
          transform: translateY(-50%);
          left: 4.25em;
        }
      }

      &[data-position='BottomLeft'] {
        @media ${theme.mq.min.tablet} {
          bottom: 0;
          left: 4.25em;
        }
      }

      &[data-position='TopRight'] {
        @media ${theme.mq.min.tablet} {
          top: 0;
          right: 4.25em;
        }
      }

      &[data-position='CenterRight'] {
        @media ${theme.mq.min.tablet} {
          top: 50%;
          transform: translateY(-50%);
          right: 4.25em;
        }
      }

      &[data-position='BottomRight'] {
        @media ${theme.mq.min.tablet} {
          bottom: 0;
          right: 4.25em;
        }
      }
    `;
  }}
`;
